import { zapiPlayOptions } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayLive = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getPlayerZapi();
    return player.playLive(parameters.cid, zapiPlayOptions(parameters.options));
};
